import { render } from "./LangButton.vue?vue&type=template&id=6da69164&scoped=true"
import script from "./LangButton.vue?vue&type=script&lang=js"
export * from "./LangButton.vue?vue&type=script&lang=js"

import "./LangButton.vue?vue&type=style&index=0&id=6da69164&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6da69164"

export default script